import { useState } from 'react';
import { handleApiError, performLogout } from './errorHandler';
import { useNavigate } from 'react-router-dom';
import { SnackbarSeverity } from '../conf/constants';
import { SnackbarState } from '../conf/type';

export function useErrorHandler(options: { redirectOnLogout?: boolean } = { redirectOnLogout: true }) {
    const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: '',
    severity: SnackbarSeverity.Success,
  });

  const handleErrorWithLogout = (error: any) => {
    const apiError = handleApiError(error);
    if (apiError.shouldLogout) {
      setSnackbar({
        open: true,
        message: 'Session expired. Redirecting to login...',
        severity: SnackbarSeverity.Warning,
      });
      setTimeout(() => {
        performLogout();
        navigate('/login');
      }, 2000);
    } else {
      setSnackbar({
        open: true,
        message: apiError.message,
        severity: apiError.severity,
      });
    }
  };

  const showSuccessMessage = (message: string) => {
    setSnackbar({
      open: true,
      message,
      severity: SnackbarSeverity.Success,
    });
  };

  const showErrorMessage = (message: string) => {
    setSnackbar({
      open: true,
      message,
      severity: SnackbarSeverity.Error,
    });
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return { snackbar, handleErrorWithLogout, showSuccessMessage,showErrorMessage, handleSnackbarClose };
}